/**
 * Lista de endpoints e códigos de status HTTP que devem ser ignorados pelo Sentry.
 *
 * Cada item do array representa uma regra de filtragem para erros de API:
 * - `endpoint`: Expressa um padrão de URL usando uma expressão regular (regex).
 *   O regex pode corresponder ao path da requisição (não à URL completa).
 * - `statuses`: Lista de códigos de status HTTP (ex: 404) que, quando retornados por esse endpoint,
 *   não devem ser reportados ao Sentry.
 *
 * Objetivo:
 * Evitar o envio de erros esperados ou recorrentes (como 404 em endpoints específicos)
 * para o Sentry, reduzindo ruído e focando apenas em erros realmente relevantes para monitoramento.
 */

export const IGNORED_ENDPOINTS_AND_STATUSES = [
  {
    endpoint: /v1\/suppliers\/[0-9a-fA-F-]{36}\/latest-order(\?.*)?$/,
    statuses: [404],
  },
  {
    endpoint: /v1\/limit-reservations/,
    statuses: [404],
  },
  {
    endpoint: /v1\/suppliers\/[0-9a-fA-F-]{36}\/merchants\/[^]+$/,
    statuses: [404],
  },
  {
    endpoint: /v1\/salespersons\/[0-9a-fA-F-]{36}\/merchants\/[^]+$/,
    statuses: [404],
  },
  {
    endpoint: /v1\/merchants\/[0-9a-fA-F-]{36}\/primary_user_contact(\?.*)?$/,
    statuses: [404],
  },
  {
    endpoint: /v1\/company\/[0-9a-fA-F-]{36}\/bills\/[0-9a-fA-F-]{36}\/snooze$/,
    statuses: [404],
  },
]
